import { DynamicCopyUsage, DynamicDrawUsage, DynamicReadUsage, StaticCopyUsage, StaticDrawUsage, StaticReadUsage, StreamCopyUsage, StreamDrawUsage, StreamReadUsage } from 'three';

export const usageValues = {
    StaticDrawUsage,
    DynamicDrawUsage,
    StreamDrawUsage,
    StaticReadUsage,
    DynamicReadUsage,
    StreamReadUsage,
    StaticCopyUsage,
    DynamicCopyUsage,
    StreamCopyUsage,
};

export const usageNames: { [v: number]: Usage } = {};
Object.keys(usageValues).forEach((k: Usage) =>
{
    usageNames[usageValues[k]] = k;
});

export type Usage = keyof typeof usageValues;
